import Vue from "vue";
import Vuex from "vuex";
import Auth from "../store/modules/auth";
import ForgotPassword from "../store/modules/forgotPassword";
import ResetPassword from "../store/modules/resetPassword";
import Stores from "../store/modules/stores";
import User from "../store/modules/user";
import UpdateUser from "../store/modules/updateUser";
import Dashboard from "../store/modules/dashboard";
import Pagination from "../store/modules/pagination";
import Library from "../store/modules/library";
import facebookLogin from "../store/modules/facebookLogin";
import roles from "../store/modules/roles";
import post from "../store/modules/post";
import details from "../store/modules/details";
import mediaManager from "../store/modules/mediaManager";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    Auth,
    ForgotPassword,
    ResetPassword,
    Stores,
    User,
    UpdateUser,
    Pagination,
    Dashboard,
    Library,
    facebookLogin,
    roles,
    post,
    details,
    mediaManager,
  },
});
